$(document).ready(function(){
  $('.tutorial-slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    dots:false,
    arrows: false,
    swipe: false,
    slidesToShow: 3,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });
});